module.exports = __webpack_public_path__ + "media/2-6-2 Mid-Autumn’s Moon.85ae3b0a.mp4";